<div [formGroup]="processingInformationFormGroup">
    <h2 class="page-header" id="processing">Processing Information <small class="text-danger">Required if Submitting to Workflow</small></h2>
    <hr />
    <div class="mb-3 row">
        <label class="col-5 col-form-label text-end pt-0">Credit Card Processing Technology</label>
        <div class="col">
            <div class="form-check">
                <input class="form-check-input" type="radio" formControlName="creditCardProcessingTechnologyCd" id="website" [value]="0" [ngClass]="{ 'is-invalid': creditCardProcessingTechnologyCd.errors && showErrors }" [attr.disabled]="disableWebsitePayment || isCashnet">
                <label class="form-check-label" for="website">
                    Website Payments
                </label>
                <small class="d-block text-muted mt-0" *ngIf="disableWebsitePayment">Becomes available if the Card Acceptance Channel percentage for Website/eCommerce Order is not 0</small>
            </div>
            <div class="form-check" *ngIf="!isCashnet">
                <input class="form-check-input" type="radio" formControlName="creditCardProcessingTechnologyCd" id="inPersonMOTO" [value]="1" [ngClass]="{ 'is-invalid': creditCardProcessingTechnologyCd.errors && showErrors }">
                <label class="form-check-label" for="inPersonMOTO">
                    In-Person & MOTO Payments
                </label>
            </div>
            <div class="form-check" *ngIf="!isCashnet">
                <input class="form-check-input" type="radio" formControlName="creditCardProcessingTechnologyCd" id="pointOfSale" [value]="2" [ngClass]="{ 'is-invalid': creditCardProcessingTechnologyCd.errors && showErrors }">
                <label class="form-check-label" for="pointOfSale">
                    Point-of-Sale Application
                </label>
            </div>
            <div *ngIf="creditCardProcessingTechnologyCd.invalid && showErrors" class="text-danger">
                <small *ngIf="creditCardProcessingTechnologyCd.errors.required">Credit Card Processing Technology is required</small>
            </div>
        </div>
    </div>

    <!--  WEBSITE PAYMENTS  -->
    <div *ngIf="creditCardProcessingTechnologyCd.value == 0 && !isCashnet">
        <div class="mb-3 row">
            <label for="paymentGatewayVendor" class="col-5 col-form-label text-end">Payment Gateway Vendor</label>
            <div class="col">
                <input type="text" class="form-control" id="paymentGatewayVendor" formControlName="paymentGatewayVendor" [ngClass]="{ 'is-invalid': paymentGatewayVendor.errors && showErrors }" maxlength="250">
                <div *ngIf="paymentGatewayVendor.invalid && showErrors" class="text-danger">
                    <small *ngIf="paymentGatewayVendor.errors.required">Payment Gateway Vendor is required</small>
                </div>
            </div>
        </div>
        <div class="mb-3 row">
            <label for="itSupportPerson" class="col-sm-5 col-form-label text-end">IT Support</label>
            <div class="col">
                <university-person id="itSupportPerson"
                                   formControlName="itSupportPerson"
                                   [canDelete]="false"
                                   (onDeletePerson)="onDeleteItSupportPerson()"
                                   [canEdit]="!itSupportPerson.disabled"
                                   [isInvalid]="itSupportPerson.errors && showErrors"></university-person>
                <div *ngIf="itSupportPerson.invalid && itSupportPerson.errors.required && showErrors" class="text-danger">
                    <small *ngIf="itSupportPerson.errors.required">IT Support is required</small>
                    <small *ngIf="itSupportPerson.errors.isActive">IT Support must be an active employee</small>
                </div>
                <div *ngIf="itSupportPerson.invalid && itSupportPerson.errors.isActive" class="text-danger">
                    <small *ngIf="itSupportPerson.errors.isActive">IT Support must be an active employee</small>
                </div>
            </div>
        </div>
    </div>

    <!--  IN-PERSON & MOTO PAYMENTS  -->
    <div *ngIf="creditCardProcessingTechnologyCd.value == 1">
        <div class="mb-3 row">
            <label class="col-5 col-form-label text-end pt-0">Type of Terminal</label>
            <div class="col">
                <div class="form-check">
                    <input class="form-check-input" type="radio" formControlName="terminalTypeCd" id="dialup" [value]="0" [ngClass]="{ 'is-invalid': terminalTypeCd.errors && showErrors }" [attr.disabled]="true">
                    <label class="form-check-label" for="dialup">
                        Credit Card Terminal (Dial-up connection) - No longer offered by Elavon
                    </label>
                </div>
                <div class="form-check">
                    <input class="form-check-input" type="radio" formControlName="terminalTypeCd" id="ipConnection" [value]="1" [ngClass]="{ 'is-invalid': terminalTypeCd.errors && showErrors }">
                    <label class="form-check-label" for="ipConnection">
                        Credit Card Terminal (IP connection)
                    </label>
                </div>
                <div class="form-check ">
                    <input class="form-check-input" type="radio" formControlName="terminalTypeCd" id="cellular" [value]="2" [ngClass]="{ 'is-invalid': terminalTypeCd.errors && showErrors }">
                    <label class="form-check-label" for="cellular">
                        Cellular Credit Card Terminal
                    </label>
                </div>
                <div class="form-check">
                    <input class="form-check-input" type="radio" formControlName="terminalTypeCd" id="virtual" [value]="3" [ngClass]="{ 'is-invalid': terminalTypeCd.errors && showErrors }">
                    <label class="form-check-label" for="virtual">
                        Virtual Terminal (web-based on staff computer)
                    </label>
                </div>
                <div *ngIf="terminalTypeCd.invalid && showErrors" class="text-danger">
                    <small *ngIf="terminalTypeCd.errors.required">Type of Terminal is required</small>
                </div>
            </div>
        </div>

        <!--  CREDIT CARD TERMINAL (IP CONNECTION) --AND-- CELLULAR CREDIT CARD TERMINAL  -->
        <div *ngIf="terminalTypeCd.value == 1 || terminalTypeCd.value == 2">
            <div class="mb-3 row">
                <label for="numberOfTerminals" class="col-5 col-form-label text-end">Number of Terminals</label>
                <div class="col">
                    <input type="number" class="form-control" id="numberOfTerminals" formControlName="numberOfTerminals" [ngClass]="{ 'is-invalid': numberOfTerminals.errors && showErrors }" maxlength="10" digitOnly>
                    <small id="numberOfTerminalsHelp" class="form-text">Max of 10 characters. Only integers are allowed.</small>
                    <div *ngIf="numberOfTerminals.invalid && showErrors" class="text-danger">
                        <small *ngIf="numberOfTerminals.errors.required">Number of Terminals is required</small>
                    </div>
                </div>
            </div>
            <div class="mb-3 row">
                <label for="itSupportPerson" class="col-sm-5 col-form-label text-end">IT Support</label>
                <div class="col">
                    <university-person id="itSupportPerson"
                                       formControlName="itSupportPerson"
                                       [canDelete]="false"
                                       (onDeletePerson)="onDeleteItSupportPerson()"
                                       [canEdit]="!itSupportPerson.disabled"
                                       [isInvalid]="itSupportPerson.errors && showErrors"></university-person>
                    <div *ngIf="itSupportPerson.invalid && itSupportPerson.errors.required && showErrors" class="text-danger">
                        <small>IT Support is required</small>
                    </div>
                    <div *ngIf="itSupportPerson.invalid && itSupportPerson.errors.isActive" class="text-danger">
                        <small>IT Support must be an active employee</small>
                    </div>
                </div>
            </div>
        </div>

        <!--  VIRTUAL TERMINAL (WEB-BASED ON STAFF COMPUTER)  -->
        <div *ngIf="terminalTypeCd.value == 3">
            <div class="mb-3 row">
                <label for="itSupportPerson" class="col-sm-5 col-form-label text-end">IT Support</label>
                <div class="col">
                    <university-person id="itSupportPerson"
                                       formControlName="itSupportPerson"
                                       [canDelete]="false"
                                       (onDeletePerson)="onDeleteItSupportPerson()"
                                       [canEdit]="!itSupportPerson.disabled"
                                       [isInvalid]="itSupportPerson.errors && showErrors"></university-person>
                    <div *ngIf="itSupportPerson.invalid && itSupportPerson.errors.required && showErrors" class="text-danger">
                        <small>IT Support is required</small>
                    </div>
                    <div *ngIf="itSupportPerson.invalid && itSupportPerson.errors.isActive" class="text-danger">
                        <small>IT Support must be an active employee</small>
                    </div>
                </div>
            </div>
            <ng-container formArrayName="processingStaffPeople">
                <div class="mb-3 row" *ngFor="let processingStaffPerson of processingStaffPeople.controls; index as i; let first = first;">
                    <label for="processingStaffPerson" class="col-sm-5 col-form-label text-end" *ngIf="first">Staff Processing Payments</label>
                    <div class="col-sm-5 text-end" *ngIf="!first">
                        <button type="button" class="btn btn-outline-danger" (click)="onDeleteProcessingStaffPerson(i)" *ngIf="!processingStaffPerson.value" title="Remove Processing Staff">
                            <fa-icon [icon]="['fas', 'times']"></fa-icon>
                        </button>
                    </div>
                    <div class="col">
                        <university-person id="processingStaffPerson"
                                           [formControlName]="i"
                                           [canDelete]="true"
                                           (onDeletePerson)="onDeleteProcessingStaffPerson(i)"
                                           [canEdit]="!processingStaffPerson.disabled"
                                           [isInvalid]="processingStaffPerson.errors && showErrors"></university-person>
                        <div *ngIf="processingStaffPerson.invalid && processingStaffPerson.errors.required && showErrors" class="text-danger">
                            <small>Staff is required</small>
                        </div>
                        <div *ngIf="processingStaffPerson.invalid && processingStaffPerson.errors.isActive" class="text-danger">
                            <small>Staff must be an active employee</small>
                        </div>
                    </div>
                </div>
            </ng-container>
            <div class="mb-3 row" *ngIf="showAddProcessingStaff()">
                <div class="col offset-5">
                    <button type="button" class="btn btn-success" (click)="onAddProcessingStaff()" title="Add Processing Staff">
                        <fa-icon [icon]="['fas', 'user-plus']"></fa-icon> Add Processing Staff
                    </button>
                </div>
            </div>
            <ng-container formArrayName="computerNames">
                <div class="mb-3 row" *ngFor="let computerName of computerNames.controls; index as i; let first = first;">
                    <label for="computerName" class="col-sm-5 col-form-label text-end" *ngIf="first">Computer Names Processing Payments</label>
                    <div class="col-sm-5 text-end" *ngIf="!first">
                        <button type="button" class="btn btn-outline-danger" (click)="onDeleteComputerName(i)" title="Remove Computer Name">
                            <fa-icon [icon]="['fas', 'times']"></fa-icon>
                        </button>
                    </div>
                    <div class="col">
                        <input type="text" class="form-control" id="computerName" [formControlName]="i" [ngClass]="{ 'is-invalid': computerName.errors && showErrors }" maxlength="50">
                        <div *ngIf="computerName.invalid && showErrors" class="text-danger">
                            <small *ngIf="computerName.errors.required">Computer Name is required</small>
                        </div>
                    </div>
                </div>
            </ng-container>
            <div class="mb-3 row" *ngIf="showAddComputerName()">
                <div class="col offset-5">
                    <button type="button" class="btn btn-success" (click)="onAddComputerName()" title="Add Computer Name">
                        <fa-icon [icon]="['fas', 'user-plus']"></fa-icon> Add Computer Name
                    </button>
                </div>
            </div>
        </div>

    </div>

    <!--  POINT-OF-SALE APPLICATION  -->
    <div *ngIf="creditCardProcessingTechnologyCd.value == 2">
        <div class="mb-3 row">
            <label for="numberOfTerminals" class="col-5 col-form-label text-end">Number of Terminals</label>
            <div class="col">
                <input type="number" class="form-control" id="numberOfTerminals" formControlName="numberOfTerminals" [ngClass]="{ 'is-invalid': numberOfTerminals.errors && showErrors }" maxlength="10" digitOnly>
                <small id="numberOfTerminalsHelp" class="form-text">Max of 10 characters. Only integers are allowed.</small>
                <div *ngIf="numberOfTerminals.invalid && showErrors" class="text-danger">
                    <small *ngIf="numberOfTerminals.errors.required">Number of Terminals is required</small>
                </div>
            </div>
        </div>
        <div class="mb-3 row">
            <label for="itSupportPerson" class="col-sm-5 col-form-label text-end">IT Support</label>
            <div class="col">
                <university-person id="itSupportPerson"
                                   formControlName="itSupportPerson"
                                   [canDelete]="false"
                                   (onDeletePerson)="onDeleteItSupportPerson()"
                                   [canEdit]="!itSupportPerson.disabled"
                                   [isInvalid]="itSupportPerson.errors && showErrors"></university-person>
                <div *ngIf="itSupportPerson.invalid && itSupportPerson.errors.required && showErrors" class="text-danger">
                    <small>IT Support is required</small>
                </div>
                <div *ngIf="itSupportPerson.invalid && itSupportPerson.errors.isActive" class="text-danger">
                    <small>IT Support must be an active employee</small>
                </div>
            </div>
        </div>
        <div class="mb-3 row">
            <label for="systemName" class="col-5 col-form-label text-end">System</label>
            <div class="col">
                <input type="text" class="form-control" id="systemName" formControlName="systemName" [ngClass]="{ 'is-invalid': systemName.errors && showErrors }" maxlength="250">
                <div class="text-center">
                    <small id="systemNameHelp" class="form-text">Name</small>
                </div>
                <div *ngIf="systemName.invalid && showErrors" class="text-danger">
                    <small *ngIf="systemName.errors.required">System Name is required</small>
                </div>
            </div>
            <div class="col">
                <input type="text" class="form-control" id="systemVersion" formControlName="systemVersion" [ngClass]="{ 'is-invalid': systemVersion.errors && showErrors }" maxlength="30">
                <div class="text-center">
                    <small id="systemVersionHelp" class="form-text">Version</small>
                </div>
                <div *ngIf="systemVersion.invalid && showErrors" class="text-danger">
                    <small *ngIf="systemVersion.errors.required">System Version is required</small>
                </div>
            </div>
        </div>
        <div class="mb-3 row">
            <label for="posPaymentGatewayVendor" class="col-5 col-form-label text-end">POS Payment Gateway Vendor</label>
            <div class="col">
                <input type="text" class="form-control" id="posPaymentGatewayVendor" formControlName="posPaymentGatewayVendor" [ngClass]="{ 'is-invalid': posPaymentGatewayVendor.errors && showErrors }" maxlength="250">
                <div *ngIf="posPaymentGatewayVendor.invalid && showErrors" class="text-danger">
                    <small *ngIf="posPaymentGatewayVendor.errors.required">POS Payment Gateway Vendor is required</small>
                </div>
            </div>
        </div>
        <div class="mb-3 row">
            <label for="posHardware" class="col-5 col-form-label text-end">POS Hardware</label>
            <div class="col">
                <input type="text" class="form-control" id="posHardware" formControlName="posHardware" [ngClass]="{ 'is-invalid': posHardware.errors && showErrors }" maxlength="250">
                <div *ngIf="posHardware.invalid && showErrors" class="text-danger">
                    <small *ngIf="posHardware.errors.required">POS Hardware is required</small>
                </div>
            </div>
        </div>
        <div class="mb-3 row">
            <label for="businessJustification" class="col-5 col-form-label text-end">Business Justification</label>
            <div class="col">
                <textarea class="form-control" id="businessJustification" formControlName="businessJustification" [ngClass]="{ 'is-invalid': businessJustification.errors && showErrors }" maxlength="2500"></textarea>
                <div *ngIf="businessJustification.invalid && showErrors" class="text-danger">
                    <small *ngIf="businessJustification.errors.required">Business Justification is required</small>
                </div>
            </div>
        </div>
        <div class="mb-3 row">
            <label for="pciComplianceDocument" class="col-5 col-form-label text-end">PCI Compliance Validation Document</label>
            <div class="col">
                <input type="file" #file (change)="updateFileValue(file.files)" style="display:none;"/>
                <button class="btn btn-secondary btn-block" type="button" (click)="file.click()" *ngIf="pciComplianceDocument.value == null">
                    <fa-icon [icon]="['fas', 'file']"></fa-icon> Select File
                </button>
                <div class="input-group" *ngIf="pciComplianceDocument.value != null">
                    <span class="form-control">
                        <span class="span-like-link" (click)="readFile()">
                            <a></a>{{pciComplianceDocument.value.fileName}}
                        </span>
                    </span>
                    <button class="btn btn-secondary" type="button" (click)="file.click()">
                        <fa-icon [icon]="['fas', 'file']"></fa-icon> Select File
                    </button>
                </div>
                <div *ngIf="pciComplianceDocument.invalid && showErrors" class="text-danger">
                    <small *ngIf="pciComplianceDocument.errors.required">PCI Compliance Validation Document is required</small>
                </div>
            </div>
        </div>
    </div>
</div>
